import React from "react";
import {
  Box,
  Grid,
  VStack,
  Text,
  IconButton,
  HStack,
  Image,
  Spinner,
  GridItem,
} from "@chakra-ui/react";
import { deleteToolsApi } from "../../../allApi/api";
import { useDispatch } from "react-redux";
import { waveflowToolsDelete } from "../../../redux/reducer/waveFlow";
import deleteBtn from "../../../assets/waveflowmain/deleteBtn.png";
import { commonStyle } from "../../../styles/commonStyle";
import { useCustomTost } from "../../../utiils/useCustomTost";
import NoTools from "./NoToolsFound";

const formatDate = (isoString) => {
  const date = new Date(isoString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const Card = ({
  title,
  model,
  createdAt,
  toolId,
  addingToolId,
  setAddingToolId,
}) => {
  const dispatch = useDispatch();
  const toast = useCustomTost();
  const isLoading = addingToolId === toolId;

  const handleDelete = async () => {
    setAddingToolId(toolId);
    try {
      const response = await deleteToolsApi(toolId);
      dispatch(waveflowToolsDelete(response));
      if (response?.message) {
        toast("Success!", "Tool deleted successfully.", "success");
      }
    } catch (error) {
      toast("Error!", error, "error");
    } finally {
      setAddingToolId(null);
    }
  };

  return (
    <Box
      bg="gray.50"
      borderRadius="md"
      h={"200px"}
      p={4}
      boxShadow="rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px"
    >
      <VStack
        h={"80%"}
        align="flex-start"
        spacing={2}
        justifyContent={"space-between"}
      >
        <Box>
          <Text fontWeight="bold" color="blue.500">
            {title}
          </Text>
          <Text fontSize="sm" color="gray.700">
            {model}
          </Text>
          {createdAt && (
            <Text fontSize="xs" color="gray.500" mt={2}>
              Created: {formatDate(createdAt)}
            </Text>
          )}
        </Box>
      </VStack>
      <HStack h={"20%"} p={0} spacing={0} justifyContent="flex-end">
        {isLoading ? (
          <Spinner thickness="2px" speed="0.65s" color="gray.500" size="sm" />
        ) : (
          <IconButton
            onClick={handleDelete}
            icon={<Image src={deleteBtn} alt="delete" w="20px" />}
            size="sm"
            colorScheme="red"
            variant="ghost"
            aria-label="Delete item"
            isDisabled={addingToolId !== null}
          />
        )}
      </HStack>
    </Box>
  );
};

const CardGrid = ({ toolsList, addingToolId, setAddingToolId }) => {
  return (
    <Grid
      w="100%"
      m="auto"
      h={"70vh"}
      templateColumns="repeat(4, 1fr)"
      gap={4}
      p={4}
      overflowY="auto"
      sx={{ ...commonStyle.sx, scrollBehavior: "smooth" }}
    >
      {toolsList && toolsList.length > 0 ? (
        toolsList.map((card, index) => (
          <Card
            key={card.id || index}
            title={card.display_name || card?.function?.name}
            model={card.description || card?.function?.description}
            createdAt={card.created_at}
            toolId={card.id}
            addingToolId={addingToolId}
            setAddingToolId={setAddingToolId}
          />
        ))
      ) : (
        <GridItem colSpan={4}>
          <NoTools />
        </GridItem>
      )}
    </Grid>
  );
};

export default CardGrid;
